// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  id: __t.u64().primaryKey(),
  worldId: __t.u64().name("world_id"),
  npc: __t.u64(),
  name: __t.string(),
  side: __t.u8(),
  rung: __t.u8(),
  survivals: __t.u8(),
  notability: __t.u16(),
  live: __t.bool(),
  protected: __t.bool(),
  lastLine: __t.string().name("last_line"),
  namedAt: __t.timestamp().name("named_at"),
  fights: __t.u32(),
});
